
import YandexShare from '@cookieseater/vue-yandex-share';
import { yaShareServices } from '@/plugins/settings';
import { getImageAllFormats } from '~/plugins/helpers/file';

export default {
  name: 'CustomYandexShare',
  components: {
    YandexShare,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: '',
    },
    imageId: {
      type: [Number, String],
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    ext: {
      type: String,
      default: 'png',
    },
  },
  data() {
    return {
      yaShareServices,
    }
  },
  computed: {
    image() {
      if (this.imageId) return null

      const image = this.getImage(this.imageId, this.ext, '', '', this.imageSrc)
      return image[this.ext][0]
    },
  },
  methods: {
    getImageAllFormats,
    getImage(id, ext, width = '', height = '', src = '') {
      return this.getImageAllFormats(id, width, height, ext ,src)
    },
  },
}
